import { RouterProvider } from 'react-router-dom';

// project import
import router from '@/routes';
import ThemeCustomization from '@/themes';

import Locales from '@/components/base-component/Locales';
import RTLLayout from '@/components/base-component/RTLLayout';
import ScrollTop from '@/components/base-component/ScrollTop';
import Customization from '@/components/base-component/customization';
import Snackbar from '@/components/base-component/extended/Snackbar';
import Notistack from '@/components/base-component/third-party/Notistack';
import { AlertProvider } from '@/contexts/alert/AlertContext';
import { BrowserRouter as Router } from 'react-router-dom';

// auth-provider
import { JWTProvider as AuthProvider } from '@/contexts/JWTContext';
// import { FirebaseProvider as AuthProvider } from '@/contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from '@/contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from '@/contexts/Auth0Context';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <AuthProvider>
              <Notistack>
                <AlertProvider>
                  <RouterProvider router={router} />
                  {/* <Customization /> */}
                  <Snackbar />
                </AlertProvider>
              </Notistack>
            </AuthProvider>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
}
